import { render, staticRenderFns } from "./ScreenFailFormModal.vue?vue&type=template&id=3f129f1b&"
import script from "./ScreenFailFormModal.vue?vue&type=script&lang=js&"
export * from "./ScreenFailFormModal.vue?vue&type=script&lang=js&"
import style0 from "./ScreenFailFormModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports